// extracted by mini-css-extract-plugin
export default {"fieldset":"mok0b6"};